import { ID } from '@vendure/core';
import { gql } from 'graphql-tag';

export function getPromotionQuery(promotionId: ID) {
    return gql`
      query promotion {
          promotion(id: ${promotionId}) {
              conditions {
                  code
                  args {
                      name
                      value
                  }
              }
          }
      }
    `;
}

export function updateCurrentVariantQuantityConditionMutation() {
    return gql`
        mutation updateCurrentVariantQuantityCondition(
            $input: UpdateCurrentVariantQuantityConditionInput!
        ) {
            updateCurrentVariantQuantityCondition(input: $input)
        }
    `;
}
